import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { flow } from 'lodash';
import { RootAction, State } from 'store/state';
import { ContactDeveloperReason } from 'utils/entities';
import { createSelector } from 'reselect';
import { userProfileSelector } from 'store/state/domainData/selectors';
import { DeveloperLeadVariables, MutationType } from 'store/sagas/apiService/types';
import { inlineMutate } from 'store/state/mutationsResponse/actions';
import Contact from './Contact';
import { developerSelector } from 'screens/DeveloperPage/selectors';


const initialValuesSelector = createSelector([ userProfileSelector, developerSelector ], (
  user,
  developer
): DeveloperLeadVariables => ({
  name: user && user.firstName,
  email: user && user.email,
  phone: user && user.phone,
  contactReason: ContactDeveloperReason.BuyProject,
  developerId: developer && developer.id,
}));


const developerLeadResponse = createSelector([
  state => state.mutationsResponse[MutationType.SubmitDeveloperLead],
  developerSelector,
], (response, developer) => developer && response && response[developer.id]);
const developerLeadIdSelector = flow(developerLeadResponse, data => data && data.data && data.data.submitDeveloperLead || null);
const submittingSelector = flow(developerLeadResponse, data => data && data.loading);
const submittedSelector = flow(developerLeadResponse, data => Boolean(data && data.data && data.data.submitDeveloperLead));

const mapStateToProps = (state: State) => ({
  developer: developerSelector(state),
  initialValues: initialValuesSelector(state),
  submitting: submittingSelector(state),
  submitted: submittedSelector(state),
  submittedLeadId: developerLeadIdSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onContactDeveloper: (data: DeveloperLeadVariables) => dispatch(inlineMutate(MutationType.SubmitDeveloperLead, { data }, data.developerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
